<template>
  <div style="height: 100%">
    <!-- 0707 新增 以地圖中央搜尋附近站點 -->
    <div class="text-btn">
      <button @click="gotoMyPoint()">{{ $t(TopMessage) }}</button>
    </div>
    <!-- 地圖 -->
    <GmapMap :options="{
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: true,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      disableDefaultUi: false,
      styles: [
        {
          featureType: 'poi',
          stylers: [{ visibility: 'off' }],
        },
        {
          featureType: 'transit',
          stylers: [{ visibility: 'off' }],
        },
      ],
    }" ref="mapRef" :zoom="17" :center="{ lat: cp_lat, lng: cp_lng }"
      style="position: absolute; left: 0; top: 0; right: 0; bottom: 0" @idle="updateCenter" @click="removeTrafficDetail">
      <GmapMarker v-if="mark_position != null" :position="mark_position" :clickable="true" :draggable="false"
        @click="center = mark_position" :icon="{
          url: 'img/map-people-new.svg',
        }"></GmapMarker>
      <GmapMarker :key="'mrt-' + index" v-for="(MetroStation, index) in TrafficData.MetroStations" :position="{
        lat: parseFloat(MetroStation.StationPosition.PositionLat),
        lng: parseFloat(MetroStation.StationPosition.PositionLon),
      }" :clickable="true" :draggable="false" :visible="TrafficType == 0 || TrafficType == 1" :icon="{
  url: 'img/map-mrt.svg',
}" @click="getMRTInfo(1, MetroStation.StationName.Zh_tw)" />
      <GmapMarker :key="'lmrt-' + index" v-for="(MetroStation, index) in TrafficData.LMetroStations" :position="{
        lat: parseFloat(MetroStation.StationPosition.PositionLat),
        lng: parseFloat(MetroStation.StationPosition.PositionLon),
      }" :clickable="true" :draggable="false" :visible="TrafficType == 0 || TrafficType == 2" :icon="{
  url: 'img/map-lrt.svg',
}" @click="getMRTInfo(2, MetroStation.StationName.Zh_tw)" />
      <GmapMarker :key="'bus-' + index" v-for="(BusStation, index) in TrafficData.BusStations" :position="{
        lat: parseFloat(BusStation.StationPosition.PositionLat),
        lng: parseFloat(BusStation.StationPosition.PositionLon),
      }" :clickable="true" :draggable="false" :visible="TrafficType == 0 || TrafficType == 3" :icon="{
  url: 'img/map-bus.svg',
}" @click="getBusInfo(BusStation.StationName.Zh_tw, BusStation.StationID)" />
      <GmapMarker :key="'bike-' + index" v-for="(BikeStation, index) in TrafficData.BikeStations" :position="{
        lat: parseFloat(BikeStation.StationPosition.PositionLat),
        lng: parseFloat(BikeStation.StationPosition.PositionLon),
      }" :clickable="true" :draggable="false" :visible="TrafficType == 0 || TrafficType == 4" :icon="{
  url: 'img/map-bike.svg',
}" @click="
  getBikeInfo(BikeStation.StationName.Zh_tw, BikeStation.StationUID)
  " />
      <GmapMarker :key="'tra-' + index" v-for="(TRAStation, index) in TrafficData.TRAStations" :position="{
        lat: parseFloat(TRAStation.StationPosition.PositionLat),
        lng: parseFloat(TRAStation.StationPosition.PositionLon),
      }" :clickable="true" :draggable="false" :visible="TrafficType == 0 || TrafficType == 6" :icon="{
  url: 'img/map-train.svg',
}" @click="getTRAInfo(6, TRAStation.StationName.Zh_tw, TRAStation.StationID)" />
    </GmapMap>
    <!-- 下方運具選項 -->
    <div class="traffic-bg" v-if="!showAllPoint && TrafficDetail == null">
      <ul class="traffic-box">
        <!-- 0519 新增 a連結 增加連結 -->
        <li class="btn-1" :class="TrafficType == 0 ? 'btn-active' : ''">
          <a style="cursor: pointer" @click="
                                            if (TrafficType == 0) {
            showAll();
          } else {
            TrafficType = 0;
          }
            ">
            <p>{{ $t("全部") }}</p>
          </a>
        </li>
        <li class="btn-2" :class="TrafficType == 1 ? 'btn-active' : ''">
          <a @click="TrafficType = 1" style="cursor: pointer">
            <p>{{ $t("捷運") }}</p>
          </a>
        </li>
        <li class="btn-3" :class="TrafficType == 2 ? 'btn-active' : ''">
          <a @click="TrafficType = 2" style="cursor: pointer">
            <p>{{ $t("輕軌") }}</p>
          </a>
        </li>
        <li class="btn-4" :class="TrafficType == 3 ? 'btn-active' : ''">
          <a @click="TrafficType = 3" style="cursor: pointer">
            <p>{{ $t("公車") }}</p>
          </a>
        </li>
        <li class="btn-5" :class="TrafficType == 4 ? 'btn-active' : ''">
          <a @click="TrafficType = 4" style="cursor: pointer">
            <p>{{ $t("腳踏車") }}</p>
          </a>
        </li>
        <li class="btn-7" :class="TrafficType == 6 ? 'btn-active' : ''">
          <a @click="TrafficType = 6" style="cursor: pointer">
            <p>{{ $t("臺鐵") }}</p>
          </a>
        </li>
        <li v-if="false" class="btn-6" :class="TrafficType == 5 ? 'btn-active' : ''">
          <a @click="TrafficType = 5" style="cursor: pointer">
            <p>{{ $t("渡輪") }}</p>
          </a>
        </li>
        <!-- 0617 新增 btn-0-->
        <!-- <li class="btn-0">
          <a @click="
              gotoUrl(
                'https://mengo.metropia.biz/trip-planning/directions',
                true
              )
              " style="cursor: pointer">
            <p>{{ $t("路線規劃") }}</p>
          </a>
        </li> -->
        <!-- 0617 新增 btn-0-->
        <!-- <li class="btn-7" v-if="UserData">
          <a
            @click="
              gotoUrl(
                'https://maas.foxconn.com/MaasBus/login?ID=' +
                  UserData.User.Account,
                true
              )
            "
            style="cursor: pointer"
          >
            <p>公車預約</p>
          </a>
        </li> -->
      </ul>
    </div>
    <div class="transparent-bg" v-if="showAllPoint">
      <div class="top-box"></div>
      <!-- 下方運具選項 -->
      <div class="traffic-bg">
        <div class="btn-line"></div>
        <ul class="box bus-box" v-if="TrafficData.MetroStations.length > 0">
          <li class="title-box">
            <div class="title">
              <img src="img/traffic-mrt.svg" alt="" />
              <p>捷運</p>
            </div>
          </li>
          <!-- 0519 新增a連結 增加連結 -->
          <li class="time-box" v-for="(MetroStation, index) in TrafficData.MetroStations" :key="index">
            <a @click="getMRTInfo(1, MetroStation.StationName.Zh_tw)" style="cursor: pointer">
              <p>
                {{ MetroStation.StationName.Zh_tw }}
              </p>
            </a>
          </li>
        </ul>
        <ul class="box bus-box" v-if="TrafficData.LMetroStations.length > 0">
          <li class="title-box">
            <div class="title">
              <img src="img/traffic-lrt.svg" alt="" />
              <p>輕軌</p>
            </div>
          </li>
          <!-- 0519 新增a連結 增加連結 -->
          <li class="time-box" v-for="(MetroStation, index) in TrafficData.LMetroStations" :key="index">
            <a @click="getMRTInfo(2, MetroStation.StationName.Zh_tw)" style="cursor: pointer">
              <p>
                {{ MetroStation.StationName.Zh_tw }}
              </p>
            </a>
          </li>
        </ul>
        <ul class="box bus-box" v-if="TrafficData.BusStations.length > 0">
          <li class="title-box">
            <div class="title">
              <img src="img/traffic-bus.svg" alt="" />
              <p>公車</p>
            </div>
          </li>
          <!-- 0519 新增a連結 增加連結 -->
          <li class="time-box" v-for="(BusStation, index) in TrafficData.BusStations" :key="index">
            <a @click="
                getBusInfo(BusStation.StationName.Zh_tw, BusStation.StationID)
                " style="cursor: pointer">
              <p>
                {{ BusStation.StationName.Zh_tw }}
              </p>
            </a>
          </li>
        </ul>
        <ul class="box bus-box" v-if="TrafficData.BikeStations.length > 0">
          <li class="title-box">
            <div class="title">
              <img src="img/traffic-bike.svg" alt="" />
              <p>腳踏車</p>
            </div>
          </li>
          <!-- 0519 新增a連結 增加連結 -->
          <li class="time-box" v-for="(BikeStation, index) in TrafficData.BikeStations" :key="index">
            <a @click="
                getBikeInfo(
                  BikeStation.StationName.Zh_tw,
                  BikeStation.StationUID
                )
                " style="cursor: pointer">
              <p>
                {{ BikeStation.StationName.Zh_tw.replace("YouBike2.0_", "") }}
              </p>
            </a>
          </li>
        </ul>
        <ul class="box bus-box" v-if="TrafficData.TRAStations.length > 0">
          <li class="title-box">
            <div class="title">
              <img src="img/traffic-train.svg" alt="" />
              <p>臺鐵</p>
            </div>
          </li>
          <!-- 0519 新增a連結 增加連結 -->
          <li class="time-box" v-for="(TRAStation, index) in TrafficData.TRAStations" :key="index">
            <a @click="getTRAInfo(6, TRAStation.StationName.Zh_tw, TRAStation.StationID)" style="cursor: pointer">
              <p>
                {{ TRAStation.StationName.Zh_tw }}
              </p>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="transparent-bg" v-if="TrafficDetail != null &&
        (TrafficDetail.TrafficType == 1 || TrafficDetail.TrafficType == 2)
        ">
      <div class="top-box"></div>
      <div class="traffic-bg">
        <div class="btn-line"></div>
        <div class="station-btn">
          <a @click="gotoUrl('https://www.krtc.com.tw/', true)" style="cursor: pointer">{{ $t("站點資訊") }}</a>
        </div>
        <ul class="box mrt-box" v-if="TrafficDetail.R">
          <li class="title-box">
            <div class="title">
              <img src="img/mrt-icon-r.svg" alt="" />
              <p>{{ $t("紅線") }}</p>
            </div>
            <div class="station">
              <p>{{ TrafficDetail.R.StationName }}</p>
              <a @click="getMRTInfo(1, TrafficDetail.R.StationName)" style="cursor: pointer">
                <img src="img/f5-w.svg" alt="" />
              </a>
            </div>
          </li>
          <li v-for="(Data, index) in TrafficDetail.R.Data" :key="index" class="time-box">
            <p>{{ Data.TripHeadSign }}</p>
            <div class="time">
              <p v-if="Data.EstimateTime > 0">
                {{ Data.EstimateTime }}{{ $t("分鐘") }}
                <span>{{ $t("下一班") }} {{ Data.NextTime }}</span>
              </p>
              <p v-if="Data.EstimateTime == 0">{{ $t("進站中") }}</p>
              <div class="next">
                <div class="arrow"></div>
                <p>{{ Data.DestinationStationName.Zh_tw }}</p>
              </div>
            </div>
          </li>
        </ul>
        <ul class="box mrt-box" v-if="TrafficDetail.O">
          <li class="title-box">
            <div class="title">
              <img src="img/mrt-icon-o.svg" alt="" />
              <p>{{ $t("橘線") }}</p>
            </div>
            <div class="station">
              <p>{{ TrafficDetail.O.StationName }}</p>
              <a @click="getMRTInfo(1, TrafficDetail.O.StationName)" style="cursor: pointer">
                <img src="img/f5-w.svg" alt="" />
              </a>
            </div>
          </li>
          <li v-for="(Data, index) in TrafficDetail.O.Data" :key="index" class="time-box">
            <p>{{ Data.TripHeadSign }}</p>
            <div class="time">
              <p v-if="Data.EstimateTime > 0">
                {{ Data.EstimateTime }}{{ $t("分鐘") }}
                <span>{{ $t("下一班") }} {{ Data.NextTime }}</span>
              </p>
              <p v-if="Data.EstimateTime == 0">{{ $t("進站中") }}</p>
              <div class="next">
                <div class="arrow"></div>
                <p>{{ Data.DestinationStationName.Zh_tw }}</p>
              </div>
            </div>
          </li>
        </ul>
        <ul class="box mrt-box" v-if="TrafficDetail.C">
          <li class="title-box">
            <div class="title">
              <p>{{ $t("輕軌") }}</p>
            </div>
            <div class="station">
              <p>{{ TrafficDetail.C.StationName }}</p>
              <a @click="getMRTInfo(2, TrafficDetail.C.StationName)" style="cursor: pointer">
                <img src="img/f5-w.svg" alt="" />
              </a>
            </div>
          </li>
          <li v-for="(Data, index) in TrafficDetail.C.Data" :key="index" class="time-box">
            <p>{{ Data.TripHeadSign }}</p>
            <div class="time">
              <p v-if="Data.EstimateTime > 0">
                {{ Data.EstimateTime }}{{ $t("分鐘") }}
                <span>{{ $t("下一班") }} {{ Data.NextTime }}</span>
              </p>
              <p v-if="Data.EstimateTime == 0">{{ $t("進站中") }}</p>
              <div class="next">
                <div class="arrow"></div>
                <p>{{ Data.DestinationStationName.Zh_tw }}</p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="transparent-bg" v-if="TrafficDetail_Bus == null &&
        TrafficDetail != null &&
        TrafficDetail.Data &&
        TrafficDetail.TrafficType == 3
        ">
      <div class="top-box"></div>
      <!-- 下方運具選項 -->
      <div class="traffic-bg">
        <div class="btn-line"></div>
        <!-- 0617 新增 logo-icon -->
        <!-- <div class="logo-icon">
          <img src="img/umaji-icon.png" alt="" />
        </div> -->
        <ul class="box bus-box">
          <li class="title-box">
            <div class="title">
              <img src="img/traffic-bus.svg" alt="" />
              <p>{{ TrafficDetail.StationName }}</p>
            </div>
            <a @click="
                getBusInfo(TrafficDetail.StationName, TrafficDetail.StationID)
                " style="cursor: pointer">
              <img src="img/f5-w.svg" alt="" />
            </a>
          </li>
          <!-- 0519 新增a連結 增加連結 -->
          <li class="time-box" v-for="(Bus, index) in TrafficDetail.Data" :key="index">
            <a @click="
                                                    if (Bus.StopStatus == 0) {
                getBusDetail(
                  TrafficDetail.StationName,
                  Bus.RouteName.Zh_tw,
                  Bus.RouteUID,
                  Bus.Direction,
                  Bus.PlateNumb
                );
              }
                " :style="Bus.StopStatus == 0 ? 'cursor: pointer' : ''">
              <p v-if="Bus.Direction == 1">
                <span>{{ Bus.RouteName.Zh_tw }}</span> {{ $t("往") }}
                {{ Bus.BusRoute.DepartureStopNameZh }}
              </p>
              <p v-else>
                <span>{{ Bus.RouteName.Zh_tw }}</span> {{ $t("往") }}
                {{ Bus.BusRoute.DestinationStopNameZh }}
              </p>
              <div class="time" v-if="Bus.StopStatus == 0">
                <div class="arrow"></div>
                <p>{{ Bus.EstimateTimeString }}</p>
              </div>
              <div class="time" v-if="Bus.StopStatus == 1">
                <p>{{ $t("尚未發車") }}</p>
              </div>
              <div class="time" v-if="Bus.StopStatus == 2">
                <p>{{ $t("交管不停靠") }}</p>
              </div>
              <div class="time" v-if="Bus.StopStatus == 3">
                <p>{{ $t("末班車已過") }}</p>
              </div>
              <div class="time" v-if="Bus.StopStatus == 4">
                <p>{{ $t("今日未營運") }}</p>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="transparent-bg" v-if="TrafficDetail_Bus != null && TrafficDetail_Bus.Data">
      <div class="top-box"></div>
      <!-- 下方運具選項 -->
      <div class="traffic-bg">
        <div class="btn-line"></div>
        <!-- 0712 新增 back -->
        <div class="back">
          <a @click="clearBusDetail()" style="cursor: pointer">{{
                $t("回上頁")
          }}</a>
        </div>
        <!-- 0617 新增 logo-icon -->
        <!-- <div class="logo-icon">
          <img src="img/umaji-icon.png" alt="" />
        </div> -->
        <ul class="box bus-box">
          <li class="title-box">
            <img src="img/traffic-bus.svg" alt="" />
            <div class="stop-sign">
              <div class="title">
                <p>{{ TrafficDetail_Bus.RouteName }}</p>
                <a @click="
                      getBusDetail(
                        TrafficDetail_Bus.StationName,
                        TrafficDetail_Bus.RouteName,
                        TrafficDetail_Bus.RouteUID,
                        TrafficDetail_Bus.Direction,
                        TrafficDetail_Bus.PlateNumb
                      )
                      " style="cursor: pointer">
                  <img src="img/f5-w.svg" alt="" />
                </a>
              </div>
              <p class="terminal">
                {{ $t("往") }} {{ TrafficDetail_Bus.DestinationStopName }}
              </p>
            </div>
          </li>
          <!-- 0519 新增a連結 增加連結 -->
          <li class="time-box" :class="Bus.StopName.Zh_tw == TrafficDetail_Bus.StationName
                ? 'active'
                : ''
                " v-for="(Bus, index) in TrafficDetail_Bus.Data" :key="index">
            <a>
              <p v-if="Bus.StopStatus == 0">
                <span>{{ Bus.StopName.Zh_tw }}</span>
              </p>
              <p v-else>
                <span>{{ Bus.StopName.Zh_tw }}</span>
              </p>
              <div class="time" v-if="Bus.StopStatus == 0">
                <div class="arrow"></div>
                <p>{{ Bus.EstimateTimeString }}</p>
              </div>
              <div class="time" v-if="Bus.StopStatus == 1">
                <p>{{ $t("尚未發車") }}</p>
              </div>
              <div class="time" v-if="Bus.StopStatus == 2">
                <p>{{ $t("交管不停靠") }}</p>
              </div>
              <div class="time" v-if="Bus.StopStatus == 3">
                <p>{{ $t("末班車已過") }}</p>
              </div>
              <div class="time" v-if="Bus.StopStatus == 4">
                <p>{{ $t("今日未營運") }}</p>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="transparent-bg" v-if="TrafficDetail != null &&
          TrafficDetail.Data &&
          TrafficDetail.TrafficType == 4
          ">
      <div class="top-box"></div>
      <!-- 下方運具選項 -->
      <div class="traffic-bg">
        <div class="btn-line"></div>
        <!-- 0617 新增 logo-icon -->
        <!-- <div class="logo-icon">
          <img src="img/umaji-icon.png" alt="" />
        </div> -->
        <div class="btn-box" style="width: 31px"></div>
        <div class="title-box">
          <div class="title">
            <img src="img/traffic-bike.svg" alt="" />
            <h1 v-if="TrafficDetail.Data.ServiceType == 1">YouBike 1.0</h1>
            <h1 v-if="TrafficDetail.Data.ServiceType == 2">YouBike 2.0</h1>
          </div>
          <a @click="
                getBikeInfo(TrafficDetail.StationName, TrafficDetail.StationUID)
                " style="cursor: pointer">
            <img src="img/f5-r.svg" alt="" />
          </a>
        </div>
        <ul class="box bike-box">
          <li class="title-box">
            <div class="title">
              <img src="img/bike-icon.png" alt="" />
              <p>{{ TrafficDetail.StationTitle }}</p>
              <!-- <p v-if="TrafficDetail.Data.ServiceStatus == 0">停止營運</p>
              <p v-if="TrafficDetail.Data.ServiceStatus == 1">正常營運</p>
              <p v-if="TrafficDetail.Data.ServiceStatus == 2">暫停營運</p> -->
            </div>
          </li>
          <li class="time-box">
            <p>
              <span><img src="img/bike-btn-y.png" alt="" /></span>
              {{ $t("單車") }}
            </p>
            <div class="time">
              <div class="arrow"></div>
              <p class="warn">{{ TrafficDetail.Data.AvailableRentBikes }}</p>
            </div>
          </li>
          <li class="time-box">
            <p>
              <span><img src="img/bike-btn-n.png" alt="" /></span>
              {{ $t("空位") }}
            </p>
            <div class="time">
              <div class="arrow"></div>
              <p>{{ TrafficDetail.Data.AvailableReturnBikes }}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="transparent-bg" v-if="TrafficDetail != null &&
          TrafficDetail.TrafficType == 6
          ">
      <div class="top-box"></div>
      <div class="traffic-bg">
        <div class="btn-line"></div>
        <div class="title-box">
          <div class="title">
            <img src="img/traffic-train.svg" alt="">
            <p>{{ TrafficDetail.StationName }}車站</p>
          </div>
        </div>
        <div class="btn_box">
          <button :class="TrafficDirection == 1 ? 'add' : ''" @click="TrafficDirection = 1">北上</button>
          <button :class="TrafficDirection == 2 ? 'add' : ''" @click="TrafficDirection = 2">南下</button>
        </div>
        <ul class="box mrt-box show" v-if="TrafficDetail.N && TrafficDirection == 1">
          <li class="title-box">
            <div class="title">
              <p>北上列車</p>
            </div>
          </li>
          <li class="time-box" v-for="(Data, index) in TrafficDetail.N.Data" :key="index">
            <p>{{ Data.TrainTypeName.Zh_tw }} {{ Data.TrainNo }}班次</p>
            <div class="time">
              <p>預計 {{ Data.ScheduledArrivalTime }} 抵達 <span v-if="Data.DelayTimeString">晚{{ Data.DelayTimeString }}</span>
              </p>
              <div class="next">
                <div class="arrow"></div>
                <p>{{ Data.EndingStationName.Zh_tw }}</p>
              </div>
            </div>
          </li>
        </ul>
        <ul class="box mrt-box show" v-if="TrafficDetail.S && TrafficDirection == 2">
          <li class="title-box">
            <div class="title">
              <p>南下列車</p>
            </div>
          </li>
          <li class="time-box" v-for="(Data, index) in TrafficDetail.S.Data" :key="index">
            <p>{{ Data.TrainTypeName.Zh_tw }} {{ Data.TrainNo }}班次</p>
            <div class="time">
              <p>預計 {{ Data.ScheduledArrivalTime }} 抵達 <span v-if="Data.DelayTimeString">晚{{ Data.DelayTimeString }}</span>
              </p>
              <div class="next">
                <div class="arrow"></div>
                <p>{{ Data.EndingStationName.Zh_tw }}</p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueI18n from "vue-i18n";
import Storage from "@/utils/storage.js";
import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueI18n);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyB_w_YJo3PKGlnHjexMMfNMFIaaWYXQ2Ck",
    libraries: "places",
  },
  installComponents: true
});

const messages = {
  zh_tw: {
    "全部": "全部",
    "捷運": "捷運",
    "輕軌": "輕軌",
    "公車": "公車",
    "腳踏車": "腳踏車",
    "渡輪": "渡輪",
    "站點資訊": "站點資訊",
    "紅線": "紅線",
    "分鐘": "分鐘",
    "下一班": "下一班",
    "進站中": "進站中",
    "橘線": "橘線",
    "往": "往",
    "尚未發車": "尚未發車",
    "交管不停靠": "交管不停靠",
    "末班車已過": "末班車已過",
    "今日未營運": "今日未營運",
    "回上頁": "回上頁",
    "單車": "單車",
    "空位": "空位",
    "正在取得定位...": "正在取得定位...",
    "以地圖中央搜尋附近站點(點此返回我的位置)": "以地圖中央搜尋附近站點(點此返回我的位置)",
    "路線規劃": "路線規劃",
  },
  en: {
    "全部": "All",
    "捷運": "MRT",
    "輕軌": "Light rail",
    "公車": "Bus",
    "腳踏車": "Bike",
    "渡輪": "Ferry",
    "站點資訊": "Station info",
    "紅線": "Red line",
    "分鐘": "Minute",
    "下一班": "Next",
    "進站中": "Arriving",
    "橘線": "Orange line",
    "往": "To",
    "尚未發車": "Not departed yet",
    "交管不停靠": "Non-stop due to traffic control",
    "末班車已過": "You've missed the last bus",
    "今日未營運": "Closed today",
    "回上頁": "Back",
    "單車": "Bike",
    "空位": "Unoccupied seat ",
    "正在取得定位...": "Getting the location...",
    "以地圖中央搜尋附近站點(點此返回我的位置)": "Search for nearby stations in the center of the map (click here to return to my location)",
    "路線規劃": "Route",
  },
  jp: {
    "全部": "全部",
    "捷運": "捷運",
    "輕軌": "輕軌",
    "公車": "公車",
    "腳踏車": "腳踏車",
    "渡輪": "渡輪",
    "站點資訊": "站點資訊",
    "紅線": "紅線",
    "分鐘": "分鐘",
    "下一班": "下一班",
    "進站中": "進站中",
    "橘線": "橘線",
    "往": "往",
    "尚未發車": "尚未發車",
    "交管不停靠": "交管不停靠",
    "末班車已過": "末班車已過",
    "今日未營運": "今日未營運",
    "回上頁": "回上頁",
    "單車": "單車",
    "空位": "空位",
    "正在取得定位...": "正在取得定位...",
    "以地圖中央搜尋附近站點(點此返回我的位置)": "以地圖中央搜尋附近站點(點此返回我的位置)",
    "路線規劃": "路線規劃",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "Map",
  i18n,
  data() {
    return {
      cp_lat: 22.63140195911536,
      cp_lng: 120.3019542914964,
      mark_position: null,
      center_position: null,
      isMobile:
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        ) != null,
      isFirstLoading: true,
      TrafficType: 0,
      idleTimerId: 0,
      TrafficData: {},
      TrafficDetail: null,
      TrafficDetail_Bus: null,
      MapZoom: 17,
      TopMessage: "正在取得定位...",
      showAllPoint: false,
      UserData: null,
      TrafficDirection: 1,
    };
  },
  watch: {
    TrafficType(newValue, oldValue) {
      this.TrafficDetail = null;
      this.TrafficDetail_Bus = null;
      if ($(".wrapper").hasClass("traffic-all")) {
        $(".wrapper").removeClass("traffic-all");
      }
      if ($(".wrapper").hasClass("traffic-mrt-lrt")) {
        $(".wrapper").removeClass("traffic-mrt-lrt");
      }
      if ($(".wrapper").hasClass("traffic-bike")) {
        $(".wrapper").removeClass("traffic-bike");
      }
      if ($(".wrapper").hasClass("traffic-bus")) {
        $(".wrapper").removeClass("traffic-bus");
      }
      if ($(".wrapper").hasClass("traffic-bus-2")) {
        $(".wrapper").removeClass("traffic-bus-2");
      }
      if ($(".wrapper").hasClass("traffic-train")) {
        $(".wrapper").removeClass("traffic-train");
      }
      this.updateCenter(null);
      // $(".wrapper").removeClass("traffic-all");
      // $(".wrapper").removeClass("traffic-bus");
      // if (newValue == 3) {
      //   $(".wrapper").addClass("traffic-all");
      //   $(".wrapper").addClass("traffic-mrt-lrt");
      // }
    },
  },
  created: function () {
    let that = this;
    $.ajax({
      url: that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/Member",
      type: "post",
      data: {
        token: Storage.get("ek_login_token"),
      },
      dataType: "json",
      error: function () { },
      success: function (res) {
        // 判斷結果
        if (res.ok) {
          that.UserData = JSON.parse(res.data);
        }
      },
    });
  },
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("traffic");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
    // 0712
    // 交通導覽 各個運具點擊按鈕上下滑動
    $(".traffic-all .traffic-bg .btn-line").click(function () {
      $(this).parent().toggleClass("aa");
      $(".traffic-bus-2 .traffic-bg").toggleClass("bb");
    });
    // 迴圈直到取得位置
    var tryTime = 0;
    let that = this;
    var loopLocal = window.setInterval(function () {
      if (Storage.isKey("lat") && Storage.isKey("lon")) {
        var lat = /*22.63140195911536;*/ Storage.get("lat");
        var lon = /*120.3019542914964;*/ Storage.get("lon");
        that.mark_position = {
          lat: parseFloat(lat),
          lng: parseFloat(lon),
        };
        if (that.isFirstLoading) {
          that.$swal.close();
          that.$refs.mapRef.$mapPromise.then((map) => {
            map.setCenter(
              new google.maps.LatLng(
                that.mark_position.lat,
                that.mark_position.lng
              )
            );
            // const circle = new google.maps.Circle({
            //   map: map,
            //   trokeColor: "#000000",
            //   strokeOpacity: 0.3,
            //   strokeWeight: 2,
            //   fillColor: "#FFFFFF",
            //   fillOpacity: 0.5,
            //   radius: 500,
            //   center: that.mark_position,
            // });
            map.setZoom(17);
            that.TopMessage = "以地圖中央搜尋附近站點(點此返回我的位置)";
          });
          that.isFirstLoading = false;
        }
      } else {
        tryTime += 1;
        if (tryTime >= 5) {
          Storage.set("lat", 22.63140195911536);
          Storage.set("lon", 120.3019542914964);
        }
      }
      // if (!that.isFirstLoading && ) {
      //   var lat = 22.63140195911536;
      //   var lon = 120.3019542914964;
      //   that.mark_position = {
      //     lat: parseFloat(lat),
      //     lng: parseFloat(lon),
      //   };
      //   that.TopMessage = "以地圖中央搜尋附近站點(點此返回美麗島)";
      //   window.clearInterval(loopLocal);
      // }
    }, 1000);
    //if (typeof cordova == "undefined" || device.platform != "Android") {
    var options = {
      enableHighAccuracy: true,
      //timeout: 10000,
      maximumAge: 5000,
    };
    navigator.geolocation.watchPosition(
      function (position) {
        Storage.set("lat", position.coords.latitude);
        Storage.set("lon", position.coords.longitude);
        console.log(
          position.coords.latitude + ", " + position.coords.longitude
        );
      },
      function (error) {
        //console.log('code: ' + error.code + ', ' + 'message: ' + error.message);
      }
    );
    //}
    this.TopMessage = "正在取得定位...";
  },
  updated: function () { },
  methods: {
    gotoMyPoint() {
      this.$refs.mapRef.$mapPromise.then((map) => {
        map.setCenter(
          new google.maps.LatLng(this.mark_position.lat, this.mark_position.lng)
        );
      });
    },
    locatorButtonPressed() {
      let that = this;
      if (Storage.isKey("lat") && Storage.isKey("lon")) {
        var lat = Storage.get("lat");
        var lon = Storage.get("lon");
        that.mark_position = {
          lat: parseFloat(lat),
          lng: parseFloat(lon),
        };
        that.$refs.mapRef.$mapPromise.then((map) => {
          map.setCenter(
            new google.maps.LatLng(
              that.mark_position.lat,
              that.mark_position.lng
            )
          );
          map.setZoom(17);
        });
      }
    },
    updateCenter(center) {
      if (!this.isFirstLoading) {
        this.$refs.mapRef.$mapPromise.then((map) => {
          this.MapZoom = map.getZoom();
          if (map.getZoom() >= 14) {
            this.center_position = map.getCenter();
            //console.log(center.lat() + ", " + center.lng());
            let that = this;
            $.ajax({
              type: "POST",
              url:
                that.GLOBAL.apiSrc +
                that.GLOBAL.subDirectory +
                "/Htmlv2/_GetTrafficData",
              data: {
                trafficType: that.TrafficType,
                lat: that.center_position.lat(),
                lon: that.center_position.lng(),
                r: 500 + (17 - that.MapZoom) * 500,
              },
              success: function (result) {
                if (result.ok) {
                  that.TrafficData = $.parseJSON(result.data);
                }
              },
            });
          } else {
            this.TrafficData = {};
            this.center_position = null;
          }
        });
      }

      // //console.log(center.lat() + ", " + center.lng());
      // if (this.idleTimerId != 0) {
      //   window.clearInterval(this.idleTimerId);
      // }
      // this.idleTimerId = window.setInterval(function () {
      //   console.log(center.lat() + ", " + center.lng());
      //   window.clearInterval(this.idleTimerId);
      // }, 3000);
    },
    removeTrafficDetail() {
      this.showAllPoint = false;
      this.TrafficDetail = null;
      this.TrafficDetail_Bus = null;
      if ($(".wrapper").hasClass("traffic-all")) {
        $(".wrapper").removeClass("traffic-all");
      }
      if ($(".wrapper").hasClass("traffic-mrt-lrt")) {
        $(".wrapper").removeClass("traffic-mrt-lrt");
      }
      if ($(".wrapper").hasClass("traffic-bike")) {
        $(".wrapper").removeClass("traffic-bike");
      }
      if ($(".wrapper").hasClass("traffic-bus")) {
        $(".wrapper").removeClass("traffic-bus");
      }
      if ($(".wrapper").hasClass("traffic-bus-2")) {
        $(".wrapper").removeClass("traffic-bus-2");
      }
      if ($(".wrapper").hasClass("traffic-train")) {
        $(".wrapper").removeClass("traffic-train");
      }
    },
    getMRTInfo(trafficType, stationName) {
      this.showAllPoint = false;
      let that = this;
      that.TopMessage = "讀取中...";
      $.ajax({
        type: "POST",
        url:
          that.GLOBAL.apiSrc +
          that.GLOBAL.subDirectory +
          "/Htmlv2/_GetTrafficDetial",
        data: {
          trafficType: trafficType,
          stationName: stationName,
        },
        success: function (result) {
          if (result.ok) {
            that.TrafficDetail = $.parseJSON(result.data);
            that.TrafficDetail_Bus = null;
            if ($(".wrapper").hasClass("traffic-bike")) {
              $(".wrapper").removeClass("traffic-bike");
            }
            if ($(".wrapper").hasClass("traffic-bus")) {
              $(".wrapper").removeClass("traffic-bus");
            }
            if ($(".wrapper").hasClass("traffic-bus-2")) {
              $(".wrapper").removeClass("traffic-bus-2");
            }
            if ($(".wrapper").hasClass("traffic-train")) {
              $(".wrapper").removeClass("traffic-train");
            }
            $(".wrapper").addClass("traffic-all");
            $(".wrapper").addClass("traffic-mrt-lrt");
          } else {
            that.TrafficDetail = null;
            that.TrafficDetail_Bus = null;
            if ($(".wrapper").hasClass("traffic-all")) {
              $(".wrapper").removeClass("traffic-all");
            }
            if ($(".wrapper").hasClass("traffic-mrt-lrt")) {
              $(".wrapper").removeClass("traffic-mrt-lrt");
            }
            if ($(".wrapper").hasClass("traffic-bike")) {
              $(".wrapper").removeClass("traffic-bike");
            }
            if ($(".wrapper").hasClass("traffic-bus")) {
              $(".wrapper").removeClass("traffic-bus");
            }
            if ($(".wrapper").hasClass("traffic-bus-2")) {
              $(".wrapper").removeClass("traffic-bus-2");
            }
            if ($(".wrapper").hasClass("traffic-train")) {
              $(".wrapper").removeClass("traffic-train");
            }
          }
          that.TopMessage = "以地圖中央搜尋附近站點(點此返回我的位置)";
        },
      });
    },
    getBikeInfo(stationName, stationUID) {
      this.showAllPoint = false;
      let that = this;
      that.TopMessage = "讀取中...";
      $.ajax({
        type: "POST",
        url:
          that.GLOBAL.apiSrc +
          that.GLOBAL.subDirectory +
          "/Htmlv2/_GetTrafficDetial",
        data: {
          trafficType: 4,
          stationName: stationName,
          stationUID: stationUID,
        },
        success: function (result) {
          if (result.ok) {
            that.TrafficDetail = $.parseJSON(result.data);
            that.TrafficDetail_Bus = null;
            if ($(".wrapper").hasClass("traffic-mrt-lrt")) {
              $(".wrapper").removeClass("traffic-mrt-lrt");
            }
            if ($(".wrapper").hasClass("traffic-bus")) {
              $(".wrapper").removeClass("traffic-bus");
            }
            if ($(".wrapper").hasClass("traffic-bus-2")) {
              $(".wrapper").removeClass("traffic-bus-2");
            }
            if ($(".wrapper").hasClass("traffic-train")) {
              $(".wrapper").removeClass("traffic-train");
            }
            $(".wrapper").addClass("traffic-all");
            $(".wrapper").addClass("traffic-bike");
          } else {
            that.TrafficDetail = null;
            that.TrafficDetail_Bus = null;
            if ($(".wrapper").hasClass("traffic-all")) {
              $(".wrapper").removeClass("traffic-all");
            }
            if ($(".wrapper").hasClass("traffic-mrt-lrt")) {
              $(".wrapper").removeClass("traffic-mrt-lrt");
            }
            if ($(".wrapper").hasClass("traffic-bike")) {
              $(".wrapper").removeClass("traffic-bike");
            }
            if ($(".wrapper").hasClass("traffic-bus")) {
              $(".wrapper").removeClass("traffic-bus");
            }
            if ($(".wrapper").hasClass("traffic-bus-2")) {
              $(".wrapper").removeClass("traffic-bus-2");
            }
            if ($(".wrapper").hasClass("traffic-train")) {
              $(".wrapper").removeClass("traffic-train");
            }
          }
          that.TopMessage = "以地圖中央搜尋附近站點(點此返回我的位置)";
        },
      });
    },
    getBusInfo(stationName, stationID) {
      this.showAllPoint = false;
      let that = this;
      that.TopMessage = "讀取中...";
      $.ajax({
        type: "POST",
        url:
          that.GLOBAL.apiSrc +
          that.GLOBAL.subDirectory +
          "/Htmlv2/_GetTrafficDetial",
        data: {
          trafficType: 3,
          stationName: stationName,
          stationID: stationID,
        },
        success: function (result) {
          if (result.ok) {
            that.TrafficDetail = $.parseJSON(result.data);
            that.TrafficDetail_Bus = null;
            if ($(".wrapper").hasClass("traffic-mrt-lrt")) {
              $(".wrapper").removeClass("traffic-mrt-lrt");
            }
            if ($(".wrapper").hasClass("traffic-bike")) {
              $(".wrapper").removeClass("traffic-bike");
            }
            if ($(".wrapper").hasClass("traffic-bus-2")) {
              $(".wrapper").removeClass("traffic-bus-2");
            }
            if ($(".wrapper").hasClass("traffic-train")) {
              $(".wrapper").removeClass("traffic-train");
            }
            $(".wrapper").addClass("traffic-all");
            $(".wrapper").addClass("traffic-bus");
          } else {
            that.TrafficDetail = null;
            that.TrafficDetail_Bus = null;
            if ($(".wrapper").hasClass("traffic-all")) {
              $(".wrapper").removeClass("traffic-all");
            }
            if ($(".wrapper").hasClass("traffic-mrt-lrt")) {
              $(".wrapper").removeClass("traffic-mrt-lrt");
            }
            if ($(".wrapper").hasClass("traffic-bike")) {
              $(".wrapper").removeClass("traffic-bike");
            }
            if ($(".wrapper").hasClass("traffic-bus")) {
              $(".wrapper").removeClass("traffic-bus");
            }
            if ($(".wrapper").hasClass("traffic-bus-2")) {
              $(".wrapper").removeClass("traffic-bus-2");
            }
            if ($(".wrapper").hasClass("traffic-train")) {
              $(".wrapper").removeClass("traffic-train");
            }
          }
          that.TopMessage = "以地圖中央搜尋附近站點(點此返回我的位置)";
        },
      });
    },
    getBusDetail(stationName, routeName, routeUId, direction, plateNumb) {
      this.showAllPoint = false;
      let that = this;
      that.TopMessage = "讀取中...";
      $.ajax({
        type: "POST",
        url:
          that.GLOBAL.apiSrc +
          that.GLOBAL.subDirectory +
          "/Htmlv2/_GetTrafficDetial_Bus",
        data: {
          stationName: stationName,
          routeName: routeName,
          routeUId: routeUId,
          direction: direction,
          plateNumb: plateNumb,
        },
        success: function (result) {
          if (result.ok) {
            that.TrafficDetail_Bus = $.parseJSON(result.data);
            if ($(".wrapper").hasClass("traffic-mrt-lrt")) {
              $(".wrapper").removeClass("traffic-mrt-lrt");
            }
            if ($(".wrapper").hasClass("traffic-bike")) {
              $(".wrapper").removeClass("traffic-bike");
            }
            if ($(".wrapper").hasClass("traffic-bus")) {
              $(".wrapper").removeClass("traffic-bus");
            }
            if ($(".wrapper").hasClass("traffic-train")) {
              $(".wrapper").removeClass("traffic-train");
            }
            $(".wrapper").addClass("traffic-all");
            $(".wrapper").addClass("traffic-bus-2");
          } else {
            that.TrafficDetail = null;
            that.TrafficDetail_Bus = null;
            if ($(".wrapper").hasClass("traffic-all")) {
              $(".wrapper").removeClass("traffic-all");
            }
            if ($(".wrapper").hasClass("traffic-mrt-lrt")) {
              $(".wrapper").removeClass("traffic-mrt-lrt");
            }
            if ($(".wrapper").hasClass("traffic-bike")) {
              $(".wrapper").removeClass("traffic-bike");
            }
            if ($(".wrapper").hasClass("traffic-bus")) {
              $(".wrapper").removeClass("traffic-bus");
            }
            if ($(".wrapper").hasClass("traffic-bus-2")) {
              $(".wrapper").removeClass("traffic-bus-2");
            }
            if ($(".wrapper").hasClass("traffic-train")) {
              $(".wrapper").removeClass("traffic-train");
            }
          }
          that.TopMessage = "以地圖中央搜尋附近站點(點此返回我的位置)";
        },
      });
    },
    clearBusDetail() {
      this.TrafficDetail_Bus = null;
      if ($(".wrapper").hasClass("traffic-bus-2")) {
        $(".wrapper").removeClass("traffic-bus-2");
      }
      $(".wrapper").addClass("traffic-bus");
    },
    gotoUrl(url, blank) {
      if (this.isMobile && typeof cordova != "undefined") {
        cordova.InAppBrowser.open(
          url,
          blank ? "_system" : "_blank",
          "location=no,hardwareback=no,footer=yes,closebuttoncaption=" +
          this.$t("關閉") +
          ",closebuttoncolor=#ffffff"
        );
      } else {
        if (blank) {
          window.open(url, "_blank");
        } else {
          window.open(url);
        }
      }
    },
    showAll() {
      if ($(".wrapper").hasClass("traffic-mrt-lrt")) {
        $(".wrapper").removeClass("traffic-mrt-lrt");
      }
      if ($(".wrapper").hasClass("traffic-bike")) {
        $(".wrapper").removeClass("traffic-bike");
      }
      if ($(".wrapper").hasClass("traffic-bus-2")) {
        $(".wrapper").removeClass("traffic-bus-2");
      }
      if ($(".wrapper").hasClass("traffic-train")) {
        $(".wrapper").removeClass("traffic-train");
      }
      $(".wrapper").addClass("traffic-all");
      $(".wrapper").addClass("traffic-bus");
      this.showAllPoint = true;
    },
    getTRAInfo(trafficType, stationName, stationID) {
      this.showAllPoint = false;
      let that = this;
      that.TopMessage = "讀取中...";
      $.ajax({
        type: "POST",
        url:
          that.GLOBAL.apiSrc +
          that.GLOBAL.subDirectory +
          "/Htmlv2/_GetTrafficDetial",
        data: {
          trafficType: trafficType,
          stationName: stationName,
          stationID: stationID,
        },
        success: function (result) {
          if (result.ok) {
            that.TrafficDetail = $.parseJSON(result.data);
            that.TrafficDetail_Bus = null;
            if ($(".wrapper").hasClass("traffic-bike")) {
              $(".wrapper").removeClass("traffic-bike");
            }
            if ($(".wrapper").hasClass("traffic-bus")) {
              $(".wrapper").removeClass("traffic-bus");
            }
            if ($(".wrapper").hasClass("traffic-bus-2")) {
              $(".wrapper").removeClass("traffic-bus-2");
            }
            $(".wrapper").addClass("traffic-all");
            $(".wrapper").addClass("traffic-mrt-lrt");
            $(".wrapper").addClass("traffic-train");
          } else {
            that.TrafficDetail = null;
            that.TrafficDetail_Bus = null;
            if ($(".wrapper").hasClass("traffic-all")) {
              $(".wrapper").removeClass("traffic-all");
            }
            if ($(".wrapper").hasClass("traffic-mrt-lrt")) {
              $(".wrapper").removeClass("traffic-mrt-lrt");
            }
            if ($(".wrapper").hasClass("traffic-bike")) {
              $(".wrapper").removeClass("traffic-bike");
            }
            if ($(".wrapper").hasClass("traffic-bus")) {
              $(".wrapper").removeClass("traffic-bus");
            }
            if ($(".wrapper").hasClass("traffic-bus-2")) {
              $(".wrapper").removeClass("traffic-bus-2");
            }
            if ($(".wrapper").hasClass("traffic-train")) {
              $(".wrapper").removeClass("traffic-train");
            }
          }
          that.TopMessage = "以地圖中央搜尋附近站點(點此返回我的位置)";
        },
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn-active {
  background-color: #173042 !important;
}

.traffic .traffic-box .btn-active p {
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Map.vue